import { useUserProfileAvailability_userProfile$key } from '#app/__generated__/relay/useUserProfileAvailability_userProfile.graphql.js';
import { useCurrentUser } from '#app/hooks/useCurrentUser.js';
import { graphql, useFragment } from '@contra/relay';

export const useUserProfileAvailability = ({
  userProfileRef,
}: {
  readonly userProfileRef: useUserProfileAvailability_userProfile$key;
}) => {
  const currentUser = useCurrentUser();
  const { hasCompletedIndyOnboarding, visitorCanEdit, workPreferences } =
    useFragment(
      graphql`
        fragment useUserProfileAvailability_userProfile on UserProfile {
          hasCompletedIndyOnboarding

          workPreferences {
            isCurrentlyAvailable
            availableUntil
          }
          visitorCanEdit
        }
      `,
      userProfileRef,
    );

  const { availableUntil, isCurrentlyAvailable } = workPreferences;

  const showAvailability =
    hasCompletedIndyOnboarding &&
    (visitorCanEdit
      ? currentUser?.selectedUserType === 'CONTRACTOR'
      : isCurrentlyAvailable);

  return {
    availableUntil,
    isCurrentlyAvailable,
    showAvailability,
  };
};
